import { ContactForm } from "../components/ContactForm";
import { ArrowIcon, MailIcon, PhoneIcon, PinIcon } from "../components/Icons";
import { PageHero } from "../components/PageHero";
import { BOOKING_URL, EMAIL, MAP_URL, PHONE_DISPLAY, PHONE_HREF } from "../site";

export function ContactPage() {
  return (
    <>
      <PageHero
        eyebrow="Contact & directions"
        title="Come see us in Englishtown."
        description="Questions, consultation requests, and special-event plans are always welcome. Call, message, or book online."
        image="/images/salon-hero.jpg"
        compact
      />
      <section className="section contact-section">
        <div className="container contact-grid">
          <div className="contact-details">
            <p className="eyebrow">Visit Nadia’s Salon</p>
            <h2>We’d love to hear what you have in mind.</h2>
            <div className="contact-methods">
              <a href={PHONE_HREF}><PhoneIcon /><span><small>Call the salon</small><strong>{PHONE_DISPLAY}</strong></span></a>
              <a href={MAP_URL} target="_blank" rel="noreferrer"><PinIcon /><span><small>Get directions</small><strong>14 Wilson Avenue, Suite 3<br />Englishtown, NJ 07726</strong></span></a>
              <a href={`mailto:${EMAIL}`}><MailIcon /><span><small>Email us</small><strong>{EMAIL}</strong></span></a>
            </div>
            <a className="button" href={BOOKING_URL} target="_blank" rel="noreferrer">Book an appointment online <ArrowIcon /></a>
            <p className="contact-note">For same-day availability or changes to an existing appointment, please call the salon directly.</p>
          </div>
          <div className="contact-form-panel">
            <h2>Send a message</h2>
            <p>We’ll use the contact details below only to respond to your inquiry.</p>
            <ContactForm />
          </div>
        </div>
      </section>
    </>
  );
}
